export default [
	{ "id": "BD", "name": "Bangladesh" },
	{ "id": "BE", "name": "Belgium" },
	{ "id": "BF", "name": "Burkina Faso" },
	{ "id": "BG", "name": "Bulgaria" },
	{ "id": "BA", "name": "Bosnia and Herzegovina" },
	{ "id": "BB", "name": "Barbados" },
	{ "id": "WF", "name": "Wallis and Futuna" },
	{ "id": "BL", "name": "Saint Barthelemy" },
	{ "id": "BM", "name": "Bermuda" },
	{ "id": "BN", "name": "Brunei" },
	{ "id": "BO", "name": "Bolivia" },
	{ "id": "BH", "name": "Bahrain" },
	{ "id": "BI", "name": "Burundi" },
	{ "id": "BJ", "name": "Benin" },
	{ "id": "BT", "name": "Bhutan" },
	{ "id": "JM", "name": "Jamaica" },
	{ "id": "BV", "name": "Bouvet Island" },
	{ "id": "BW", "name": "Botswana" },
	{ "id": "WS", "name": "Samoa" },
	{ "id": "BQ", "name": "Bonaire, Saint Eustatius and Saba" },
	{ "id": "BR", "name": "Brazil" },
	{ "id": "76", "name": "Brazil" },
	{ "id": "BS", "name": "Bahamas" },
	{ "id": "JE", "name": "Jersey" },
	{ "id": "BY", "name": "Belarus" },
	{ "id": "BZ", "name": "Belize" },
	{ "id": "RU", "name": "Russia" },
	{ "id": "RW", "name": "Rwanda" },
	{ "id": "RS", "name": "Serbia" },
	{ "id": "TL", "name": "East Timor" },
	{ "id": "RE", "name": "Reunion" },
	{ "id": "TM", "name": "Turkmenistan" },
	{ "id": "TJ", "name": "Tajikistan" },
	{ "id": "RO", "name": "Romania" },
	{ "id": "TK", "name": "Tokelau" },
	{ "id": "GW", "name": "Guinea-Bissau" },
	{ "id": "GU", "name": "Guam" },
	{ "id": "GT", "name": "Guatemala" },
	{ "id": "GS", "name": "South Georgia and the South Sandwich Islands" },
	{ "id": "GR", "name": "Greece" },
	{ "id": "GQ", "name": "Equatorial Guinea" },
	{ "id": "GP", "name": "Guadeloupe" },
	{ "id": "JP", "name": "Japan" },
	{ "id": "GY", "name": "Guyana" },
	{ "id": "GG", "name": "Guernsey" },
	{ "id": "GF", "name": "French Guiana" },
	{ "id": "GE", "name": "Georgia" },
	{ "id": "GD", "name": "Grenada" },
	{ "id": "GB", "name": "United Kingdom" },
	{ "id": "GA", "name": "Gabon" },
	{ "id": "SV", "name": "El Salvador" },
	{ "id": "GN", "name": "Guinea" },
	{ "id": "GM", "name": "Gambia" },
	{ "id": "GL", "name": "Greenland" },
	{ "id": "GI", "name": "Gibraltar" },
	{ "id": "GH", "name": "Ghana" },
	{ "id": "OM", "name": "Oman" },
	{ "id": "TN", "name": "Tunisia" },
	{ "id": "JO", "name": "Jordan" },
	{ "id": "HR", "name": "Croatia" },
	{ "id": "HT", "name": "Haiti" },
	{ "id": "HU", "name": "Hungary" },
	{ "id": "HK", "name": "Hong Kong" },
	{ "id": "HN", "name": "Honduras" },
	{ "id": "HM", "name": "Heard Island and McDonald Islands" },
	{ "id": "VE", "name": "Venezuela" },
	{ "id": "PR", "name": "Puerto Rico" },
	{ "id": "PS", "name": "Palestinian Territory" },
	{ "id": "PW", "name": "Palau" },
	{ "id": "PT", "name": "Portugal" },
	{ "id": "SJ", "name": "Svalbard and Jan Mayen" },
	{ "id": "PY", "name": "Paraguay" },
	{ "id": "IQ", "name": "Iraq" },
	{ "id": "PA", "name": "Panama" },
	{ "id": "PF", "name": "French Polynesia" },
	{ "id": "PG", "name": "Papua New Guinea" },
	{ "id": "PE", "name": "Peru" },
	{ "id": "PK", "name": "Pakistan" },
	{ "id": "PH", "name": "Philippines" },
	{ "id": "PN", "name": "Pitcairn" },
	{ "id": "PL", "name": "Poland" },
	{ "id": "PM", "name": "Saint Pierre and Miquelon" },
	{ "id": "ZM", "name": "Zambia" },
	{ "id": "EH", "name": "Western Sahara" },
	{ "id": "EE", "name": "Estonia" },
	{ "id": "EG", "name": "Egypt" },
	{ "id": "ZA", "name": "South Africa" },
	{ "id": "EC", "name": "Ecuador" },
	{ "id": "IT", "name": "Italy" },
	{ "id": "VN", "name": "Vietnam" },
	{ "id": "SB", "name": "Solomon Islands" },
	{ "id": "ET", "name": "Ethiopia" },
	{ "id": "SO", "name": "Somalia" },
	{ "id": "ZW", "name": "Zimbabwe" },
	{ "id": "SA", "name": "Saudi Arabia" },
	{ "id": "ES", "name": "Spain" },
	{ "id": "ER", "name": "Eritrea" },
	{ "id": "ME", "name": "Montenegro" },
	{ "id": "MD", "name": "Moldova" },
	{ "id": "MG", "name": "Madagascar" },
	{ "id": "MF", "name": "Saint Martin" },
	{ "id": "MA", "name": "Morocco" },
	{ "id": "MC", "name": "Monaco" },
	{ "id": "UZ", "name": "Uzbekistan" },
	{ "id": "MM", "name": "Myanmar" },
	{ "id": "ML", "name": "Mali" },
	{ "id": "MO", "name": "Macao" },
	{ "id": "MN", "name": "Mongolia" },
	{ "id": "MH", "name": "Marshall Islands" },
	{ "id": "MK", "name": "Macedonia" },
	{ "id": "MU", "name": "Mauritius" },
	{ "id": "MT", "name": "Malta" },
	{ "id": "MW", "name": "Malawi" },
	{ "id": "MV", "name": "Maldives" },
	{ "id": "MQ", "name": "Martinique" },
	{ "id": "MP", "name": "Northern Mariana Islands" },
	{ "id": "MS", "name": "Montserrat" },
	{ "id": "MR", "name": "Mauritania" },
	{ "id": "IM", "name": "Isle of Man" },
	{ "id": "UG", "name": "Uganda" },
	{ "id": "TZ", "name": "Tanzania" },
	{ "id": "MY", "name": "Malaysia" },
	{ "id": "MX", "name": "Mexico" },
	{ "id": "IL", "name": "Israel" },
	{ "id": "FR", "name": "France" },
	{ "id": "IO", "name": "British Indian Ocean Territory" },
	{ "id": "SH", "name": "Saint Helena" },
	{ "id": "FI", "name": "Finland" },
	{ "id": "FJ", "name": "Fiji" },
	{ "id": "FK", "name": "Falkland Islands" },
	{ "id": "FM", "name": "Micronesia" },
	{ "id": "FO", "name": "Faroe Islands" },
	{ "id": "NI", "name": "Nicaragua" },
	{ "id": "NL", "name": "Netherlands" },
	{ "id": "NO", "name": "Norway" },
	{ "id": "NA", "name": "Namibia" },
	{ "id": "VU", "name": "Vanuatu" },
	{ "id": "NC", "name": "New Caledonia" },
	{ "id": "NE", "name": "Niger" },
	{ "id": "NF", "name": "Norfolk Island" },
	{ "id": "NG", "name": "Nigeria" },
	{ "id": "NZ", "name": "New Zealand" },
	{ "id": "NP", "name": "Nepal" },
	{ "id": "NR", "name": "Nauru" },
	{ "id": "NU", "name": "Niue" },
	{ "id": "CK", "name": "Cook Islands" },
	{ "id": "XK", "name": "Kosovo" },
	{ "id": "CI", "name": "Ivory Coast" },
	{ "id": "CH", "name": "Switzerland" },
	{ "id": "CO", "name": "Colombia" },
	{ "id": "CN", "name": "China" },
	{ "id": "CM", "name": "Cameroon" },
	{ "id": "CL", "name": "Chile" },
	{ "id": "CC", "name": "Cocos Islands" },
	{ "id": "CA", "name": "Canada" },
	{ "id": "CG", "name": "Republic of the Congo" },
	{ "id": "CF", "name": "Central African Republic" },
	{ "id": "CD", "name": "Democratic Republic of the Congo" },
	{ "id": "CZ", "name": "Czech Republic" },
	{ "id": "CY", "name": "Cyprus" },
	{ "id": "CX", "name": "Christmas Island" },
	{ "id": "CR", "name": "Costa Rica" },
	{ "id": "CW", "name": "Curacao" },
	{ "id": "CV", "name": "Cape Verde" },
	{ "id": "CU", "name": "Cuba" },
	{ "id": "SZ", "name": "Swaziland" },
	{ "id": "SY", "name": "Syria" },
	{ "id": "SX", "name": "Sint Maarten" },
	{ "id": "KG", "name": "Kyrgyzstan" },
	{ "id": "KE", "name": "Kenya" },
	{ "id": "SS", "name": "South Sudan" },
	{ "id": "SR", "name": "Suriname" },
	{ "id": "KI", "name": "Kiribati" },
	{ "id": "KH", "name": "Cambodia" },
	{ "id": "KN", "name": "Saint Kitts and Nevis" },
	{ "id": "KM", "name": "Comoros" },
	{ "id": "ST", "name": "Sao Tome and Principe" },
	{ "id": "SK", "name": "Slovakia" },
	{ "id": "KR", "name": "South Korea" },
	{ "id": "SI", "name": "Slovenia" },
	{ "id": "KP", "name": "North Korea" },
	{ "id": "KW", "name": "Kuwait" },
	{ "id": "SN", "name": "Senegal" },
	{ "id": "SM", "name": "San Marino" },
	{ "id": "SL", "name": "Sierra Leone" },
	{ "id": "SC", "name": "Seychelles" },
	{ "id": "KZ", "name": "Kazakhstan" },
	{ "id": "KY", "name": "Cayman Islands" },
	{ "id": "SG", "name": "Singapore" },
	{ "id": "SE", "name": "Sweden" },
	{ "id": "SD", "name": "Sudan" },
	{ "id": "DO", "name": "Dominican Republic" },
	{ "id": "DM", "name": "Dominica" },
	{ "id": "DJ", "name": "Djibouti" },
	{ "id": "DK", "name": "Denmark" },
	{ "id": "VG", "name": "British Virgin Islands" },
	{ "id": "DE", "name": "Germany" },
	{ "id": "YE", "name": "Yemen" },
	{ "id": "DZ", "name": "Algeria" },
	{ "id": "US", "name": "United States" },
	{ "id": "UY", "name": "Uruguay" },
	{ "id": "YT", "name": "Mayotte" },
	{ "id": "UM", "name": "United States Minor Outlying Islands" },
	{ "id": "LB", "name": "Lebanon" },
	{ "id": "LC", "name": "Saint Lucia" },
	{ "id": "LA", "name": "Laos" },
	{ "id": "TV", "name": "Tuvalu" },
	{ "id": "TW", "name": "Taiwan" },
	{ "id": "TT", "name": "Trinidad and Tobago" },
	{ "id": "TR", "name": "Turkey" },
	{ "id": "LK", "name": "Sri Lanka" },
	{ "id": "LI", "name": "Liechtenstein" },
	{ "id": "LV", "name": "Latvia" },
	{ "id": "TO", "name": "Tonga" },
	{ "id": "LT", "name": "Lithuania" },
	{ "id": "LU", "name": "Luxembourg" },
	{ "id": "LR", "name": "Liberia" },
	{ "id": "LS", "name": "Lesotho" },
	{ "id": "TH", "name": "Thailand" },
	{ "id": "TF", "name": "French Southern Territories" },
	{ "id": "TG", "name": "Togo" },
	{ "id": "TD", "name": "Chad" },
	{ "id": "TC", "name": "Turks and Caicos Islands" },
	{ "id": "LY", "name": "Libya" },
	{ "id": "VA", "name": "Vatican" },
	{ "id": "VC", "name": "Saint Vincent and the Grenadines" },
	{ "id": "AE", "name": "United Arab Emirates" },
	{ "id": "AD", "name": "Andorra" },
	{ "id": "AG", "name": "Antigua and Barbuda" },
	{ "id": "AF", "name": "Afghanistan" },
	{ "id": "AI", "name": "Anguilla" },
	{ "id": "VI", "name": "U.S. Virgin Islands" },
	{ "id": "IS", "name": "Iceland" },
	{ "id": "IR", "name": "Iran" },
	{ "id": "AM", "name": "Armenia" },
	{ "id": "AL", "name": "Albania" },
	{ "id": "AO", "name": "Angola" },
	{ "id": "AQ", "name": "Antarctica" },
	{ "id": "AS", "name": "American Samoa" },
	{ "id": "AR", "name": "Argentina" },
	{ "id": "AU", "name": "Australia" },
	{ "id": "AT", "name": "Austria" },
	{ "id": "AW", "name": "Aruba" },
	{ "id": "IN", "name": "India" },
	{ "id": "AX", "name": "Aland Islands" },
	{ "id": "AZ", "name": "Azerbaijan" },
	{ "id": "IE", "name": "Ireland" },
	{ "id": "ID", "name": "Indonesia" },
	{ "id": "UA", "name": "Ukraine" },
	{ "id": "QA", "name": "Qatar" },
	{ "id": "MZ", "name": "Mozambique" }]
